import API from "../../common/utils/API";
import {displayWarningMessage} from "../../common/marvel-reducers/formMessageActions";
import {checkUpdateTimeActionTypes} from "../veritas-middleware/constants/UtilityMiddlewareConstants";
import {
    apiActionsBillingGroups,
    apiActionsCountries,
    apiActionsDP,
    apiActionsDPService,
    apiActionsDPSource
} from "../veritas-middleware/constants/ApiMiddlewareConstants";

/**
 * This is the Middleware to check the last-updated time of the requested resource.
 * Currently, only handles the else case correctly. Notification / Messaging around
 * the true case is TBD.
 * @param store, action
 * @returns Makes the API call, compares the last updated attribute of the resource
 * and conditionally dispatches the Update action.
 */
const checkUpdateMiddleware = (store) => (next) => (action) => {
    switch (action.type) {

        case checkUpdateTimeActionTypes.DATA_PROVIDER: {
            next(action);
            const { dataProviderID, providerObject, authToken } = action.payload;

            API.getOneDataProvider(dataProviderID, authToken.idToken)
                .then(res => {
                    const dpData = res.data;
                    // if the last updated times do not match, notify the user
                    if (dpData.provider_detail.last_updated !== providerObject.provider_detail.last_updated) {
                        // let path = `/dataproviders/edit/${this.state.provider_id}`
                        // Notifications.showPageUpdatedMessage(path)

                    // else update the Data Provider
                    } else {
                        store.dispatch({
                            type: apiActionsDP.PUT,
                            payload: { dataProviderID, providerObject, authToken }
                        })
                    }
                })
                .catch(error => console.log(error));

            break;
        }

        case checkUpdateTimeActionTypes.DP_SERVICE: {
            next(action);

            const { serviceID, serviceObject, toDelete, authToken } = action.payload;

            if (serviceObject.service_detail.dp_type === 'kyc') {
                API.getDPServiceByID(serviceID, authToken.idToken)
                    .then(res => {
                        const dpData = res.data;
                        // if the last updated times do not match, notify the user
                        if (dpData.service_detail.last_updated !== serviceObject.service_detail.last_updated) {
                            // let path = `/dataproviders/edit/${this.state.provider_id}`
                            // Notifications.showPageUpdatedMessage(path)
                            const message = [];
                            message.push("This has already been updated by another user.");
                            store.dispatch(displayWarningMessage(message, true));

                            // else update the DP Service
                        } else {
                            const reqObj = {
                                serviceObject: serviceObject,
                                toDelete: toDelete
                            }
                            store.dispatch({
                                type: apiActionsDPService.PUT,
                                payload: { serviceID, reqObj, authToken }
                            })
                        }
                    })
                    .catch(error => console.log(error));

            } else if (serviceObject.service_detail.dp_type === 'kyb') {
                API.getKYBServiceByID(serviceID, authToken.idToken)
                    .then(res => {
                        const dpData = res.data;
                        // if the last updated times do not match, notify the user
                        if (dpData.service_detail.last_updated !== serviceObject.service_detail.last_updated) {
                            // let path = `/dataproviders/edit/${this.state.provider_id}`
                            // Notifications.showPageUpdatedMessage(path)
                            const message = [];
                            message.push("This has already been updated by another user.");
                            store.dispatch(displayWarningMessage(message, true));

                            // else update the DP Service
                        } else {
                            const reqObj = {
                                serviceObject: serviceObject,
                                toDelete: toDelete
                            }
                            store.dispatch({
                                type: apiActionsDPService.PUT_KYB,
                                payload: { serviceID, reqObj, authToken }
                            })
                        }
                    })
                    .catch(error => console.log(error));
            }

            break;
        }

        case checkUpdateTimeActionTypes.DP_SOURCE: {

            const { sourceID, sourceObject, resourceType, toDelete, authToken } = action.payload;

            next(action);

            if (resourceType === "kyc") {
                // check that the DP Source was not updated since the information was originally called
                API.getDPSourceByID(sourceID, authToken.idToken)
                    .then(res => {
                        const dpSourceData = res.data.source_detail;

                        // if the last updated times do not match, notify the user
                        if (dpSourceData.last_updated !== sourceObject.source_detail.last_updated) {
                            // let path = `/veritas/dpsource/edit/${this.state.dpSourceID}`;
                            // Notifications.showPageUpdatedMessage(path);

                            const message = [];
                            message.push("This has already been updated by another user.");
                            store.dispatch(displayWarningMessage(message, true));

                            // else update the DP Source
                        } else {
                            const dpSourceObj = {
                                sourceObject,
                                toDelete
                            }
                            store.dispatch({
                                type: apiActionsDPSource.PUT,
                                payload: {sourceID, dpSourceObj, authToken},
                            })
                        }
                    })
                    .catch(err => console.log(err));
            } else {
                // check that the DP Source was not updated since the information was originally called
                API.getKYBSourceByID(sourceID, authToken.idToken)
                    .then(res => {
                        const dpSourceData = res.data.source_detail;

                        // if the last updated times do not match, notify the user
                        if (dpSourceData.last_updated !== sourceObject.source_detail.last_updated) {
                            // let path = `/veritas/dpsource/edit/${this.state.dpSourceID}`;
                            // Notifications.showPageUpdatedMessage(path);

                            const message = [];
                            message.push("This has already been updated by another user.");
                            store.dispatch(displayWarningMessage(message, true));

                            // else update the DP Source
                        } else {
                            const dpSourceObj = {
                                sourceObject,
                                toDelete
                            }
                            store.dispatch({
                                type: apiActionsDPSource.PUT_KYB,
                                payload: {sourceID, dpSourceObj, authToken},
                            })
                        }
                    })
                    .catch(err => console.log(err));
            }

            break;
        }

        case checkUpdateTimeActionTypes.COUNTRY: {
         next(action);

         const { countryID, countryObj, authToken } = action.payload;
         API.getOneCountry(countryID, authToken.idToken)
             .then(res => {
                     const countryDetail = res.data.country_detail;

                     if (countryDetail.last_updated !== countryObj.last_updated) {
                         const message = [];
                         message.push("This Country has already been updated by another user.");
                         store.dispatch(displayWarningMessage(message, true));
                     } else {
                         store.dispatch({
                             type: apiActionsCountries.PUT,
                             payload: {countryID, countryObj, authToken},
                         });
                     }
                 }
             )
             .catch(err => console.error(err));

         break;
        }

        case checkUpdateTimeActionTypes.BILLING_GROUP: {
            next(action);

            const { billingGroupID, billingGroupObj, authToken } = action.payload;
            API.getOneBillingGroup(billingGroupID, authToken.idToken)
                .then(res => {
                        const billingGroupDetail = res.data;

                        if (billingGroupDetail.last_updated !== billingGroupObj.last_updated) {
                            const message = [];
                            message.push("This Billing Group has already been updated by another user.");
                            store.dispatch(displayWarningMessage(message, true));
                        } else {
                            store.dispatch({
                                type: apiActionsBillingGroups.PUT,
                                payload: {billingGroupID, billingGroupObj, authToken},
                            });
                        }
                    }
                )
                .catch(err => console.error(err));

            break;
        }

        default: next(action);
    }
}

export default checkUpdateMiddleware;
